import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormInput, FormButton, Margin, Text } from 'shared/components'

import * as styles from './styles'

const UserFormComponent = ({ form, onSubmitForm }) => (
  <Form form={form} onSubmit={onSubmitForm}>
    <Margin bottom={2}>
      <Text as="label" size={18} bold white>
        Required Info:
      </Text>
    </Margin>
    <Margin tb={2}>
      <FormInput
        isRequired
        name="nickName"
        label="Nickname"
        placeholder="johndoe"
        strictLong
      />
    </Margin>
    <Margin bottom={1}>
      <FormInput
        isRequired
        name="email"
        label="Email"
        type="email"
        placeholder="account@email.com"
        strictLong
      />
    </Margin>

    <Margin tb={2}>
      <FormInput
        isRequired
        name="password"
        label="Password"
        type="password"
        placeholder="********"
        strictLong
      />
    </Margin>
    <Margin tb={2}>
      <FormInput
        isRequired
        name="confirmation"
        label="Confirm Password"
        type="password"
        placeholder="********"
        strictLong
      />
    </Margin>
    <Margin bottom={2} top={4}>
      <Text as="label" size={18} bold white>
        Additional Info:
      </Text>
    </Margin>
    <Margin tb={2}>
      <FormInput
        name="firstName"
        label="First Name"
        placeholder="John"
        strictLong
      />
    </Margin>
    <Margin tb={2}>
      <FormInput
        name="lastName"
        label="Last Name"
        placeholder="Doe"
        strictLong
      />
    </Margin>

    <Margin top={2} css={styles.buttonContainer}>
      <FormButton
        submit
        medium
        green
        css={[styles.signupButton, { marginLeft: '8px' }]}
      >
        <Text size={16} upper bold black>
          Sign Up
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

UserFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmitForm: PropTypes.func.isRequired,
}

export default UserFormComponent
